/**
 * Shared menu styling constants
 * Used by dropdown menus, context menus, and other menu-like components
 * to maintain consistency with sidebar styling.
 */

/**
 * Base classes for dropdown menu items
 * Matches SidebarMenuButton default size (text-sm, h-8)
 */
export const dropdownMenuItemClasses =
  "w-full flex items-center gap-3 px-3 py-1.5 text-sm transform-gpu hover:scale-[1.02] hover:shadow-md active:scale-[0.98] bg-transparent relative rounded-xl transition-[background-color,transform] duration-200 text-gray-900 dark:text-white hover:bg-gray-200 dark:hover:bg-zinc-700/70 outline-none shadow-none data-[highlighted]:bg-gray-200 dark:data-[highlighted]:bg-zinc-700/70 data-[highlighted]:scale-[1.02] data-[highlighted]:shadow-md";

/**
 * Destructive variant for delete/remove actions
 * Maintains red text color on hover and uses a light red background
 */
export const dropdownMenuItemDestructiveClasses =
  "text-red-600 dark:text-red-400 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-100 dark:hover:bg-red-400/15 data-[highlighted]:bg-red-100 dark:data-[highlighted]:bg-red-400/15 data-[highlighted]:text-red-600 dark:data-[highlighted]:text-red-400";

/**
 * Base classes for floating submenu items (e.g., Help submenu)
 * Uses text-sm to match sidebar styling
 */
export const floatingSubmenuItemClasses =
  "px-4 py-2 text-sm transition-colors duration-150 rounded-xl mx-1 outline-none focus:bg-gray-200 dark:focus:bg-zinc-700/70 focus:text-accent-foreground focus-visible:ring-2 focus-visible:ring-purple-400 focus-visible:ring-offset-1 focus-visible:relative focus-visible:z-[100] text-gray-900 dark:text-white hover:bg-gray-200 dark:hover:bg-zinc-700/70";

/**
 * Classes for external link submenu items (with arrow indicator)
 */
export const floatingSubmenuLinkClasses =
  "flex items-center justify-between " + floatingSubmenuItemClasses;

/**
 * Classes for block-level internal link submenu items
 */
export const floatingSubmenuBlockClasses =
  "block " + floatingSubmenuItemClasses;

/**
 * Classes for button/action submenu items
 */
export const floatingSubmenuButtonClasses =
  "block w-full text-left " + floatingSubmenuItemClasses;
